/// <amd-module name="Agile/Common/Constants/BacklogsHubTelemetryConstants" />
export namespace BacklogsHubTelemetryConstants {
    export const PLANNING_NAVIGATE_TO_BACKLOG = "Planning_Navigate_To_Backlog";
    export const PLANNING_NAVIGATE_TO_ITERATION = "Planning_Navigate_To_Iteration";
    export const PLANNING_NEW_SPRINT_OPENED = "Planning_NewSprint_Opened";
    export const PLANNING_ITEM_DROPPED = "Planning_ItemDropped";
    export const PLANNING_ITEM_DROPPED_BACKLOG = "Planning_ItemDropped_Backlog";
    
}